import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { FoldableListChatSkeleton } from '@/components/modules/Chat/FoldableListChat';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { SelectableListItem } from '@/components/ui/List/SelectableList';
import { Card } from '@/components/ui/Surface/Card';
import { hotlineClientNegotiateContentStyle } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientNegotiateContent/style';
/**
 * 匿名コンサルホットライン クライアント チャット内容 スケルトン表示
 */
export const HotlineClientNegotiateContentSkeleton = (props) => {
    const { className = '', displayContent = true } = props;
    const style = hotlineClientNegotiateContentStyle();
    return (_jsxs(_Fragment, { children: [_jsx(SelectableListItem, Object.assign({ className: style.base() }, { children: _jsx(Skeleton, { className: 'w-full h-[20px]' }) })), displayContent && (_jsx("div", Object.assign({ className: style.contentWrap() }, { children: _jsx("div", { children: _jsxs(Card, Object.assign({ className: style.content({ class: className }), isRounded: true }, { children: [_jsx(Skeleton, { className: 'h-[20px] w-[160px]' }), _jsx(FoldableListChatSkeleton, { className: style.chatWrap() }), _jsx(Skeleton, { className: style.scheduleContent({
                                    class: 'h-[320px] w-full',
                                }) })] })) }) })))] }));
};
